export default __webpack_public_path__ + "static/media/banner_news.bec0ebb1.jpg";